import { CurrencyPipe, DatePipe, DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { DisplayLabelPipe, ShorthandSymbolPipe } from '@zero/shared/ui-pipes';
import { OrderPushData } from '@zero/shared/util-models';
import { TradeService } from '@zero/trade/domain';
import { commonRoutes } from 'constants/web-app-constants';
import { OrderShouldBeRepeatedPipe } from './pipes/order-should-be-repeated.pipe';
import { SnackbarHasOrderStatusPipe } from './pipes/snackbar-has-order-status.pipe';

@Component({
  selector: 'web-components-snackbar-order-msg',
  templateUrl: './snackbar-order-msg.component.html',
  imports: [
    RouterLink,
    DecimalPipe,
    CurrencyPipe,
    DatePipe,
    TranslocoPipe,
    ShorthandSymbolPipe,
    DisplayLabelPipe,
    NgTemplateOutlet,
    SnackbarHasOrderStatusPipe,
    OrderShouldBeRepeatedPipe,
  ],
})
export class SnackbarOrderMsgComponent implements OnInit {
  @Input() public order: OrderPushData;

  public readonly buyAndSell = commonRoutes.postlogin.buyAndSell;
  public readonly instrumentDetails = commonRoutes.postlogin.instrument_detail;
  public orderExecutedValue: number;
  public isDividendReinvest: boolean;

  readonly #tradeService = inject(TradeService);
  readonly #router = inject(Router);

  ngOnInit(): void {
    const { execPrice, executedQuantity, minimumQuantitySurcharge, fractionalSurcharge, provision, direction, metadata } = this.order;
    const surcharge = (minimumQuantitySurcharge + fractionalSurcharge + provision) * (direction === 'buy' ? 1 : -1);
    this.orderExecutedValue = executedQuantity * execPrice + surcharge;
    this.isDividendReinvest = metadata && 'DIVIDEND_REINVEST' in metadata;
  }

  public async oppositeOrder() {
    this.#router.navigate([this.buyAndSell], {
      queryParams: {
        isin: this.order.isin,
        direction: this.order.direction === 'buy' ? 'sell' : 'buy',
        quantity: this.order.quantity,
      },
    });
  }

  public async repeatOrder() {
    this.#router.navigate([this.buyAndSell], {
      queryParams: this.#tradeService.createQueryParams(this.order),
    });
  }
}
